exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scaling-policy-modal input,\n.scaling-policy-modal select {\n  margin: 0 5px;\n}\n.scaling-policy-modal span.input-label,\n.scaling-policy-modal .select-placeholder {\n  display: inline-block;\n  font-size: 12px;\n}\n.scaling-policy-modal .chart .line-series path {\n  stroke-width: 2px;\n}\n.scaling-policy-modal .chart .axis {\n  font-family: 'Source Sans Pro', sans-serif;\n}\n.scaling-policy-modal .section-additional-settings .row {\n  margin-bottom: 10px;\n}\n.scaling-policy-modal aws-alarm-configurer > .row {\n  margin-bottom: 10px;\n}\n.scaling-policy-modal .sm-label-right {\n  padding-right: 5px;\n}\n.scaling-policy-modal .content-fields {\n  padding-left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/upsert/upsertScalingPolicy.modal.less
// module id = 3474
// module chunks = 0